import { createSelector } from '@reduxjs/toolkit';
import { getTermsValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectGarageType = createSelector(selectJsonQuery, jsonQuery => getTermsValue('garage_type')(jsonQuery));
